/* -----------------UI--------------- */
import Box from "@memorang/ui/components/Box";
import { TextSkeleton } from "@memorang/ui/components/ChatUI/TextSkeleton";
import { ScrollView } from "react-native";

export const SuggestedActionsChipsSkeleton = ({
	height = 40,
}: {
	height?: number;
}) => {
	return (
		<ScrollView
			horizontal
			contentContainerStyle={{
				gap: 8,
				flex: 1,
			}}
		>
			<Box flexDirection="row" gap={8}>
				{/* Two chip skeletons */}
				<Box width={150}>
					<TextSkeleton numLines={1} height={height} />
				</Box>
				<Box width={150}>
					<TextSkeleton numLines={1} height={height} />
				</Box>
			</Box>
		</ScrollView>
	);
};
